import Intro from "../components/intro/Intro";
import About from "../components/about/About";
import Stats from "../components/stats/Stats";
import Timeline from "../components/timeline/Timeline";
import Contact from "../components/contact/Contact";
import SideIndex from "../components/sideindex/SideIndex";

export default function Home() {
  return (
    <>
      <SideIndex />
      <div className="page">
        <Intro />
      </div>
      <div className="sections">
        <About />
        <Stats />
        <Timeline />
        <Contact />
      </div>
    </>
  );
}
